import { Component } from '@angular/core';
import moment from 'moment-timezone';

@Component({
    selector: 'app-marketing-footer-black',
    templateUrl: './marketing-footer-black.component.html',
    styleUrls: [
        './marketing-footer-black.component.scss',
        '../../shared-marketing.component.scss',
    ],
})
export class MarketingFooterBlackComponent
{
    today: string = moment().format('YYYY');
}
